import React, {useState, useEffect, useRef} from 'react';
import apiClient from '../../context/apiClient'
import ExcelIcon from '../../assets/icons/Excel.svg'
import Arrow from '../../assets/icons/Arrow.svg'
import Download from '../../assets/icons/Download.svg'


const categories = [
    'KONZEPTION_ADE_3',
    'AES_THEMEN',
    'FUS_KURSVORBEREITUNG',
    'FUS_KURSNACHBEREITUNG',
    'VOR_NACH_AUSSENSTANDORT',
    'NICHT_EVENT',
    'VOR_NACH_HALLE_NEUBURG',
    'ADEC_BUERO_ARBEIT',
    'FUS_LOGISTIK_BUERO',
    'ADEC_MOBILES_ARBEITEN',
    'FUS_ABENDESSEN',
    'FUS_KURSDURCHFUEHRUNG',
    'KURSDURCHFUEHRUNG_INSTRUKTOREN',
    'KURSDURCHFUEHRUNG_MECHANIKER',
    'KURSDURCHFUEHRUNG_GUESTMANAGER',
    'FUS_REISEZEIT',
    'FUS_ARBEITSZEIT',
    'ADEC_COUNTER',
    'DEFAULT_WORK'
];

const roleLabels = {
    INSTRUCTOR: 'Instruktoren',
    MECHANIC: 'Mechaniker',
    GUEST_MANAGER: 'Guestmanager',
};

const virtualCategoryMapping = {
    KURSDURCHFUEHRUNG_INSTRUKTOREN: [
        'FUS_ABENDESSEN',
        'FUS_KURSDURCHFUEHRUNG',
        'FUS_KURSNACHBEREITUNG',
        'FUS_KURSVORBEREITUNG',
        'NICHT_EVENT'
    ],
    KURSDURCHFUEHRUNG_MECHANIKER: [
        'FUS_KURSDURCHFUEHRUNG',
        'FUS_REISEZEIT',
        'VOR_NACH_AUSSENSTANDORT'
    ],
    KURSDURCHFUEHRUNG_GUESTMANAGER: [
        'FUS_KURSDURCHFUEHRUNG',
        'FUS_KURSVORBEREITUNG',
        'FUS_KURSNACHBEREITUNG',
        'FUS_REISEZEIT'
    ],
}



const categoryLabels = {
    KONZEPTION_ADE_3: 'Konzeption ADE 3',
    AES_THEMEN: 'AES Themen',
    FUS_KURSVORBEREITUNG: 'Kursvorbereitung',
    FUS_KURSNACHBEREITUNG: 'Kursnachbereitung',
    VOR_NACH_AUSSENSTANDORT: 'Vor-/Nachbereitung (Außenstandort)',
    NICHT_EVENT: 'Nicht-Event Einsätze',
    VOR_NACH_HALLE_NEUBURG: 'Halle',
    ADEC_BUERO_ARBEIT: 'ADEC Büroarbeit',
    FUS_LOGISTIK_BUERO: 'FUS Logistik Büro',
    ADEC_MOBILES_ARBEITEN: 'ADEC mobiles Arbeiten',
    FUS_ABENDESSEN: 'FUS Abendessen',
    FUS_KURSDURCHFUEHRUNG: 'FUS Kursdurchführung',
    KURSDURCHFUEHRUNG_INSTRUKTOREN : 'Kursdurchführung (Instruktoren)',
    KURSDURCHFUEHRUNG_MECHANIKER : 'Kursdurchführung (Mechaniker)',
    KURSDURCHFUEHRUNG_GUESTMANAGER : 'Kursdurchführung (Guestmanager)',
    FUS_REISEZEIT: 'FUS Reisezeit',
    FUS_ARBEITSZEIT: 'FUS Arbeitszeit',
    ADEC_COUNTER: 'ADEC Counter',
    DEFAULT_WORK: 'Sonstige Arbeit',
};

const roleStyles = {
    INSTRUCTOR: 'bg-indigo-300',
    MECHANIC: 'bg-emerald-300',
    GUEST_MANAGER: 'bg-rose-300'
}

function formatForInput(date) {
    const pad = (n) => n.toString().padStart(2, '0');
    const yyyy = date.getFullYear();
    const MM = pad(date.getMonth() + 1);
    const dd = pad(date.getDate());
    const hh = pad(date.getHours());
    const mm = pad(date.getMinutes());
    return `${yyyy}-${MM}-${dd}T${hh}:${mm}`;
}

export default function StundenkontingenteDownloadPage() {
    const today = new Date();
    const firstDayLastMonth = new Date(today.getFullYear(), today.getMonth() - 1, 1);
    const lastDayLastMonth = new Date(today.getFullYear(), today.getMonth(), 0, 23, 59);

    const [selectedCategories, setSelectedCategories] = useState(['FUS_KURSDURCHFUEHRUNG']);
    const [startDate, setStartDate] = useState(firstDayLastMonth);
    const [endDate, setEndDate] = useState(lastDayLastMonth);
    const [allUsers, setAllUsers] = useState([])
    const [selectedUsers, setSelectedUsers] = useState([])
    const [search, setSearch] = useState('')
    const [roles, setRoles] = useState([])
    const [isLoading, setIsLoading] = useState(false)
    const [open, setOpen] = useState(false);


    useEffect(() => {
        const fetchData = async () => {
            const res = await apiClient.get('/api/employee/all', {withCredentials: true})
            setAllUsers(res.data)
            setRoles([...new Set(res.data.map(u => u.role))])
        }
        fetchData()
    }, [])

    const handleRoleToggle = (role) => {
        const usersOfRole = allUsers.filter(u => u.role === role)
        const isSelected = selectedUsers.some(u => u.role === role)
        setSelectedUsers(prev => isSelected
            ? prev.filter(u => u.role !== role)
            : [...prev, ...usersOfRole.filter(u => !prev.some(s => s.id === u.id))]
        )
    }

    const handleDownload = async () => {
        if (!startDate || !endDate || selectedUsers.length === 0) return

        setIsLoading(true)

        try {
            const params = new URLSearchParams({
                categories: selectedCategories
                .filter(cat => !cat.startsWith('KURSDURCHFUEHRUNG_'))
                .join(','),
                employeeIds: selectedUsers.map(u => u.id).join(','),
                startTime: formatForInput(startDate),
                endTime: formatForInput(endDate)
            }).toString()

            const res = await apiClient.get(`/api/employee/getStundenkontingente?${params}`, {
                responseType: 'blob',
                withCredentials: true,
            })

            const url = window.URL.createObjectURL(new Blob([res.data]))
            const a = document.createElement('a')
            a.href = url
            a.download = `Stunden_${selectedCategories[0]}.xlsx`;
            a.click()
        } catch (err) {
            console.error('Download fehlgeschlagen:', err)
        } finally {
            setIsLoading(false)
        }
    }

    const dropdownRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);


    return (
        <main className="flex-1 h-full w-full flex flex-col">
            <section className="bg-white p-6 rounded shadow space-y-1 mb-6">
                <h2 className="text-xl font-bold text-center">Wählen Sie die Eventkategorie und den Zeitraum des
                    Downloads</h2>
                <div className="flex gap-4">
                    <div className="flex flex-col w-1/3 relative" ref={dropdownRef}>
                        <label className="text-sm font-medium text-gray-700 mb-1">Kategorien</label>
                        <button
                            onClick={() => setOpen(prev => !prev)}
                            className="w-full border rounded px-3 py-2 text-left text-sm bg-white hover:bg-gray-50"
                        >
                            <div className="flex items-center w-full">
                                <span
                                    className="truncate max-w-[calc(100%-1rem)]"
                                    title={selectedCategories.map(cat => categoryLabels[cat] || cat).join(', ')}
                                >
                                  {selectedCategories.length > 0
                                      ? selectedCategories.map(cat => categoryLabels[cat] || cat).join(', ')
                                      : 'Kategorien wählen'}
                                </span>
                            </div>
                        </button>
                        {open && (
                            <div
                                className="absolute mt-1 z-10 w-full border rounded bg-white shadow max-h-48 overflow-y-auto">
                                {categories.map(cat => (
                                    <label
                                        key={cat}
                                        className="flex items-center gap-2 px-3 py-1 text-sm hover:bg-gray-100 cursor-pointer"
                                    >
                                        <input
                                            type="checkbox"
                                            className="form-checkbox"
                                            checked={selectedCategories.includes(cat)}
                                            onChange={() => {
                                                const isVirtual = virtualCategoryMapping[cat] !== undefined;
                                                setSelectedCategories(prev => {
                                                    if (prev.includes(cat)) {
                                                        // Entferne virtuelle + zugeordnete echte Kategorien
                                                        const remove = new Set([cat, ...(isVirtual ? virtualCategoryMapping[cat] : [])]);
                                                        return prev.filter(c => !remove.has(c));
                                                    } else {
                                                        // Füge virtuelle + echte Kategorien hinzu, ohne Duplikate
                                                        const add = isVirtual ? [cat, ...virtualCategoryMapping[cat]] : [cat];
                                                        return Array.from(new Set([...prev, ...add]));
                                                    }
                                                });
                                            }}
                                        />
                                        {categoryLabels[cat] || cat}
                                    </label>
                                ))}
                            </div>
                        )}
                    </div>
                    <div className="flex flex-col w-1/3">
                        <label className="text-sm font-medium text-gray-700 mb-1">Startzeit</label>
                        <input
                            type="datetime-local"
                            value={formatForInput(startDate)}
                            onChange={e => setStartDate(new Date(e.target.value))}
                            className="border px-3 py-2 rounded"
                        />
                    </div>
                    <div className="flex flex-col w-1/3">
                        <label className="text-sm font-medium text-gray-700 mb-1">Endzeit</label>
                        <input
                            type="datetime-local"
                            value={formatForInput(endDate)}
                            onChange={e => setEndDate(new Date(e.target.value))}
                            className="border px-3 py-2 rounded"
                        />

                    </div>
                </div>
            </section>

            {/* Auswahlbereich */}
            <section
                className="bg-white p-6 rounded shadow grid grid-cols-3 gap-6 w-full h-full overflow-hidden mb-6">

                {/* Spalte 1: Suche + Personenauswahl */}
                <div className="flex flex-col space-y-4 overflow-hidden">
                    {/* Suche */}
                    <div className="w-full">
                        <input
                            type="text"
                            placeholder="Suche"
                            value={search}
                            onChange={e => setSearch(e.target.value)}
                            className="w-full border rounded px-3 py-2"
                        />
                    </div>

                    {/* Benutzerliste */}
                    <div className="grid grid-cols-2 gap-x-4 gap-y-2 overflow-y-auto pr-1 auto-rows-min">
                        {allUsers
                            .filter(u =>
                                u.firstName.toLowerCase().includes(search.toLowerCase()) &&
                                !selectedUsers.some(s => s.id === u.id)
                            )
                            .map(u => {
                                const selected = selectedUsers.some(p => p.id === u.id)
                                const roleColor = roleStyles[u.role] || 'bg-gray-200'

                                return (
                                    <button
                                        key={u.id}
                                        onClick={() => {
                                            setSelectedUsers(prev =>
                                                selected
                                                    ? prev.filter(p => p.id !== u.id)
                                                    : [...prev, u]
                                            );
                                            setSearch(''); // Reset search after selection
                                        }}
                                        className={`
                                            relative flex items-center pr-4 pl-5 py-1 text-xs text-gray-800 
                                            border border-gray-300 rounded-full bg-white
                                            transition h-7
                                        `}
                                        style={{width: '100%'}}
                                    >
                                        <div
                                            className={`absolute left-0 top-0 h-full w-[5%] rounded-l-full ${roleColor}`}/>
                                        <span className="truncate">{u.firstName} {u.lastName}</span>
                                    </button>
                                )
                            })}
                    </div>
                </div>

                {/* Spalte 2 (mittig) */}
                <div className="flex h-full items-center justify-center">
                    <div className="flex items-center justify-center gap-10">
                        {/* Linke Hälfte: Rollen mit Toggles */}
                        <div className="flex flex-col gap-4 justify-center">
                            {roles.map(role => {
                                const isActive = allUsers
                                    .filter(u => u.role === role)
                                    .every(u => selectedUsers.some(s => s.id === u.id));
                                return (
                                    <div key={role} className="flex items-center justify-between gap-3">
                                        <span className="text-sm text-gray-800 truncate">
                                            <span className="text-sm text-gray-800 truncate">
                                                Alle {roleLabels[role] || role}
                                            </span>

                                        </span>
                                        <button
                                            role="switch"
                                            aria-checked={isActive}
                                            onClick={() => handleRoleToggle(role)}
                                            className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors duration-200 ${
                                                isActive ? 'bg-gray-800' : 'bg-white border border-gray-400'
                                            } focus:outline-none`}
                                        >
                                            <span
                                                className={`inline-block h-4 w-4 transform rounded-full transition-transform duration-200 ${
                                                    isActive ? 'translate-x-5 bg-white' : 'translate-x-1 bg-gray-600'
                                                }`}
                                            />
                                        </button>
                                    </div>
                                );
                            })}
                        </div>

                        {/* Rechte Hälfte: Pfeil */}
                        <div className="flex justify-center items-center">
                            <img src={Arrow} alt="Arrow" className="w-40 h-40"/>
                        </div>
                    </div>
                </div>


                <div className="flex flex-col overflow-hidden">
                    {/* Überschrift */}
                    <div className="mb-2 text-center">
                        <h2 className="text-xl font-bold">Ihre ausgewählten Filter</h2>
                    </div>

                    {/* Scrollbarer Bereich wie links */}
                    <div className="grid grid-cols-2 gap-x-4 gap-y-2 overflow-y-auto pr-1 auto-rows-min">
                        {selectedUsers.map(u => {
                            const roleColor = roleStyles[u.role] || 'bg-gray-200';
                            return (
                                <div
                                    key={u.id}
                                    onClick={() =>
                                        setSelectedUsers(prev => prev.filter(p => p.id !== u.id))
                                    }
                                    title="Aus Auswahl entfernen"
                                    className={`
                                        group
                                        relative flex items-center pr-4 pl-5 py-1 text-xs text-gray-800 
                                        border border-gray-300 rounded-full bg-white 
                                        hover:bg-red-100 transition cursor-pointer 
                                        h-7 w-full
                                      `}
                                >
                                    <div
                                        className={`absolute left-0 top-0 h-full w-[5%] rounded-l-full ${roleColor}`}/>
                                    <span className="truncate">{u.firstName} {u.lastName}</span>
                                    <span
                                        className="absolute right-2 text-gray-400 group-hover:text-red-500 text-sm font-bold pointer-events-none">
                                        ✕
                                    </span>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </section>
            {/* Download Button */}
            <section className="flex justify-center">
                <button
                    onClick={handleDownload}
                    disabled={isLoading || !startDate || !endDate || selectedUsers.length === 0}
                    className={`
                      flex items-center justify-center gap-2
                      w-72 h-20 rounded-xl border border-black 
                      shadow-md bg-white hover:bg-gray-100 
                      disabled:opacity-50 disabled:cursor-not-allowed
                    `}
                >
                    {isLoading ? (
                        <svg className="animate-spin h-6 w-6 text-gray-800" xmlns="http://www.w3.org/2000/svg"
                             fill="none" viewBox="0 0 24 24">
                            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor"
                                    strokeWidth="4"/>
                            <path className="opacity-75" fill="currentColor"
                                  d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"/>
                        </svg>
                    ) : (
                        <>
                            <img src={ExcelIcon} alt="Excel" className="w-10 h-10"/>
                            <img src={Download} alt="Download" className="w-10 h-10"/>
                        </>
                    )}
                </button>
            </section>

        </main>
    )
}
